import React, { useState } from "react";
import "./Register.css";
import GradientButton from "../../components/button/Button";
import { Logo } from "../../images/Images";
import axiosInstance from "../../axiosInstance"; // Import your Axios instance
import { toast } from "react-toastify"; // Notification for success or error

const CreateBusiness: React.FC = () => {
  const [loading, setLoading] = useState(false);

  const [apiErrorObj, setApiErrorObj] = useState<any>(null);
  // State to manage form inputs
  const [formData, setFormData] = useState({
    businessName: "",
    tagline: "",
    description: "",
    taxId: "",
    email: "",
    phone: "",
  });

  // State to manage validation errors
  const [validationErrors, setValidationErrors] = useState({
    businessName: "",
    tagline: "",
    description: "",
    taxId: "",
    email: "",
    phone: "",
  });

  // Handle input changes
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Clear validation error for the field
    setValidationErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  // Validate inputs
  const validateInputs = () => {
    const errors: any = {};

    if (!formData.businessName.trim())
      errors.businessName = "Business name is required.";
    if (!formData.tagline.trim()) errors.tagline = "Tagline is required.";
    if (!formData.description.trim())
      errors.description = "Description is required.";
    if (!formData.taxId.trim())
      errors.taxId = "Tax Identification Number is required.";
    if (!formData.email.trim()) {
      errors.email = "Email is required.";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      errors.email = "Invalid email format.";
    }
    if (!formData.phone.trim()) errors.phone = "Phone number is required.";

    setValidationErrors(errors);

    // Return true if no errors
    return Object.keys(errors).length === 0;
  };

  // Handle form submission
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    // Validate inputs
    if (!validateInputs()) {
      toast.error("Please fix the errors in the form.");
      return;
    }

    // API payload
    const payload = {
      name: formData.businessName,
      tagline: formData.tagline,
      description: formData.description,
      tax_id: formData.taxId,
      email: formData.email,
      phone: formData.phone,
    };

    console.log("Payload for API:", payload); // Log payload

    try {
      // Send to API
      const response = await axiosInstance.post("/ventures", payload);
      toast.success("Business profile created successfully!");
      console.log("API Response:", response.data);

      window.location.href = "/create-business-address";

      // Clear form after successful submission
      setFormData({
        businessName: "",
        tagline: "",
        description: "",
        taxId: "",
        email: "",
        phone: "",
      });
      setLoading(false);
    } catch (error: any) {
      setLoading(false);

      const apiResponse = error.response?.data;
      setApiErrorObj(apiResponse?.errors || null); // Store error object for debug

      if (apiResponse?.errors) {
        setLoading(false);

        // Show field errors first
        const fieldErrors = apiResponse.errors;
        setValidationErrors((prev) => ({
          ...prev,
          ...fieldErrors,
        }));
        Object.entries(fieldErrors).forEach(([field, message]) => {
          toast.error(`${field}: ${message}`);
        });
      } else if (apiResponse?.message) {
        // Only show message if there are no field errors
        toast.error(apiResponse.message);
      } else {
        setLoading(false);
        toast.error(
          error.response?.data?.message ||
            "Something went wrong while creating the business profile."
        );
      }
    }
  };
  return (
    <div className="login-page">
      {/* Left-side Image */}
      <div className="login-page__image">
        <img
          src="https://img.freepik.com/free-photo/top-view-vegetables-fruits-zucchini-bell-peppers-apples-quince-cherry-tomatoes-cumcuat-parsley-cabbage-lemon-pomegranates_140725-59438.jpg?uid=R27806234&ga=GA1.1.1852762410.1725342281&semt=ais_hybrid"
          alt="Fresh Produce"
        />
      </div>

      {/* Right-side Form */}
      <div className="login-page__form-container">
        <form className="login-page__form" onSubmit={handleSubmit}>
          <div className="login-page__title">
            <img src={Logo} alt="logo" />
          </div>
          <h2 className="login-page__subtitle">Setup your Business Profile</h2>
          <p className="login-page__description">Let’s get started </p>

          {/* Input Fields */}

          <div className="login-page__input-group">
            <label>Business Name </label>
            <input
              type="text"
              name="businessName"
              placeholder="E.g John Doe and Sons Groceries"
              value={formData.businessName}
              onChange={handleChange}
              required
            />
            {validationErrors.businessName && (
              <p className="error-text">{validationErrors.businessName}</p>
            )}
          </div>

          <div className="login-page__input-group">
            <label>Tagline</label>
            <input
              type="text"
              name="tagline"
              placeholder="E.g Fresh groceries at your doorstep"
              value={formData.tagline}
              onChange={handleChange}
              required
            />
            {validationErrors.tagline && (
              <p className="error-text">{validationErrors.tagline}</p>
            )}
          </div>

          <div className="login-page__input-group">
            <label>Business Description </label>
            <input
              type="text"
              name="description"
              placeholder="E.g John Doe and Sons Groceries is a shop that sells fresh groceries..."
              value={formData.description}
              onChange={handleChange}
              required
            />
            {validationErrors.description && (
              <p className="error-text">{validationErrors.description}</p>
            )}
          </div>

          <div className="login-page__input-group">
            <label>Business Tax Identification Number </label>
            <input
              type="text"
              name="taxId"
              placeholder="E.g TIN-9727981"
              value={formData.taxId}
              onChange={handleChange}
              required
            />
            {validationErrors.taxId && (
              <p className="error-text">{validationErrors.taxId}</p>
            )}
          </div>

          <div className="login-page__input-group">
            <label>Business Email Address</label>
            <input
              type="email"
              name="email"
              placeholder="E.g JohnDoe@gmail.com"
              value={formData.email}
              onChange={handleChange}
              required
            />
            {validationErrors.email && (
              <p className="error-text">{validationErrors.email}</p>
            )}
          </div>

          <div className="login-page__input-group">
            <label>Business Phone Number</label>
            <input
              type="text"
              name="phone"
              placeholder="E.g +1(281)7048844"
              value={formData.phone}
              onChange={handleChange}
              required
            />
            {validationErrors.phone && (
              <p className="error-text">{validationErrors.phone}</p>
            )}
          </div>

          <div className="gd-btn">
            <GradientButton text={loading ? "Loading..." : "Submit"} />
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateBusiness;
